import { OrderedMap } from 'immutable';
import AllViewFilter from './viewFilters/AllViewFilter';
import { MyTeamViewFilter } from './viewFilters/TeamViewFilter';
import { MyUserViewFilter } from './viewFilters/UserViewFilter';
import * as DefaultFilterNames from 'SalesContentIndexUI/data/lib/DefaultFilterNames';
export default (({
  looseItemContentType,
  folderContentType,
  getUserId,
  getTeamIds,
  additionalViewFilters,
  useOwnerViewFilters
}) => {
  return OrderedMap().set(DefaultFilterNames.ALL, AllViewFilter({
    looseItemContentType,
    folderContentType
  })).set(useOwnerViewFilters ? DefaultFilterNames.OWNED_BY_MY_TEAM : DefaultFilterNames.CREATED_BY_MY_TEAM, MyTeamViewFilter({
    looseItemContentType,
    folderContentType,
    getTeamIds,
    useOwnerViewFilters
  })).set(useOwnerViewFilters ? DefaultFilterNames.OWNED_BY_ME : DefaultFilterNames.CREATED_BY_ME, MyUserViewFilter({
    looseItemContentType,
    folderContentType,
    getUserId,
    useOwnerViewFilters
  })).merge(additionalViewFilters);
});